import { ErrorView } from "@/components/ui/layout/error/errorView"
import { PayoutDetailsInfo } from "@/modules/finances/financesPayout/components/payoutDetailsInfo"
import { PayoutDetailsInfoSkeleton } from "@/modules/finances/financesPayout/components/payoutDetailsInfoSkeleton"
import type { PayoutEnumApi } from "@/modules/finances/financesPayout/gateway/payoutApi"
import { useSidebar } from "@/modules/sidebar/hooks/useSidebar"
import type { SidebarNavigatorParams } from "@/modules/sidebar/sidebarTypes"
import { FinanceFeesLayout } from "@modules/finances/components/financeFeesLayout"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"

export const useFinanceSidebar = () => {
  const { addSidebarStackOnTop, sidebarNavigateTo } = useSidebar()

  const navigateToFinanceFeesLayout = (addOnTop: boolean = false) => {
    if (addOnTop) {
      addSidebarStackOnTop({
        content: <FinanceFeesLayout />,
      })
    } else {
      sidebarNavigateTo({
        content: <FinanceFeesLayout />,
      })
    }
  }

  const navigateToPayoutDetails = (payoutEnumApi: PayoutEnumApi, payoutId: string, args: SidebarNavigatorParams) => {
    return sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<PayoutDetailsInfoSkeleton />}>
            <PayoutDetailsInfo payoutEnumApi={payoutEnumApi} payoutId={payoutId} />
          </Suspense>
        </ErrorBoundary>
      ),
      replaceAllComponents: true,
      ...args,
    })
  }

  return {
    navigateToFinanceFeesLayout,
    navigateToPayoutDetails,
  }
}
